import { createAsyncThunk } from "@reduxjs/toolkit";
import { type AxiosResponse } from "axios";
import { awsClientGateway } from "./common/gateway";
import { logMessage } from "../utils/amplifyLogger";
import { clientLog } from "./logging";

export const getGlobalConfig = createAsyncThunk<AxiosResponse | unknown, void>(
  "globalConfig/getGlobalConfig",
  async (_args, { rejectWithValue }) => {
    try {
      return await awsClientGateway({
        pathTemplate: `/globalConfig`,
        method: "GET",
      });
    } catch (error) {
      clientLog({
        component: `globalConfig`,
        message: `Something went wrong in getGlobalConfig API => ${error}`,
      });
      logMessage(
        `globalConfig API`,
        `Something went wrong in getGlobalConfig API => ${error}`,
        `error`,
      );
      return rejectWithValue("Error in getGlobalConfig api endpoint");
    }
  },
);
